import React from 'react';

const SERVICES = [
  { id: 'basic', name: 'Basic Wash', description: 'Exterior wash, dry, and tire shine.', price: 75 },
  { id: 'deluxe', name: 'Deluxe Detail', description: 'Exterior + quick interior vacuum and wipe down.', price: 150 },
  { id: 'premium', name: 'Premium Detail', description: 'Full interior + exterior detail and protection.', price: 250 },
];

const EXTRAS = [
  { id: 'pet', name: 'Pet Hair Removal', price: 25 },
  { id: 'engine', name: 'Engine Bay Clean', price: 40 },
  { id: 'headlights', name: 'Headlight Restoration', price: 60 },
];

export default function ServiceSelector({ value, onChange }){
  const toggleExtra = (id) => {
    const next = new Set(value.extras || []);
    if(next.has(id)) next.delete(id); else next.add(id);
    onChange({ ...value, extras: Array.from(next) });
  };

  const selectedService = value.serviceId || 'basic';

  return (
    <div className="service-selector">
      <h2>Select a Package</h2>
      <div className="cards">
        {SERVICES.map(s => (
          <label key={s.id} className={`card ${selectedService === s.id ? 'selected': ''}`}>
            <input
              type="radio"
              name="service"
              value={s.id}
              checked={selectedService === s.id}
              onChange={() => onChange({ ...value, serviceId: s.id })}
              style={{ display: 'none' }}
            />
            <div className="card-top">
              <h3>{s.name}</h3>
              <div className="price">${s.price}</div>
            </div>
            <p className="muted">{s.description}</p>
          </label>
        ))}
      </div>

      <h3 style={{ marginTop: 24 }}>Add-ons</h3>
      <div className="extras">
        {EXTRAS.map(x => (
          <label key={x.id} className={`chip ${value.extras?.includes(x.id) ? 'selected': ''}`}>
            <input
              type="checkbox"
              checked={value.extras?.includes(x.id) || false}
              onChange={() => toggleExtra(x.id)}
              style={{ display: 'none' }}
            />
            {x.name} (+${x.price})
          </label>
        ))}
      </div>
    </div>
  );
}

export { SERVICES, EXTRAS };
